import { useCallback } from "react"

import { useNavigate as RRDUseNavigate } from "react-router-dom"

import { NavigationOrigins } from "../constants/navigationOrigins"
import { useApplicationDispatchContext } from "../contexts/ApplicationContext"

export const useNavigate = () => {
    const navigate = RRDUseNavigate()
    const { setNavigationOrigin } = useApplicationDispatchContext()

    const enhancedNavigate = useCallback((to, options = {}) => {
        const {
            navigationOrigin,
            ...navigationOptions
        } = options
        setNavigationOrigin(navigationOrigin || NavigationOrigins.NONE)
        return navigate(to, navigationOptions)
    }, [navigate, setNavigationOrigin])

    return enhancedNavigate
}